import React from 'react';
import Portal from '@ui-kit/components/portal';
import ReactCanvasConfetti from 'react-canvas-confetti';
import styles from '../styles/modal.module.scss';

function randomInRange(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

const canvasStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0
}

export default class Fireworks extends React.Component<{isFire: boolean; stopAnimation?: () => void}> {
  constructor(props: any, 
    private isAnimationEnabled: boolean,
    private animationInstance: any,
    private intervalId: NodeJS.Timeout | null,
  ) {
    super(props);
    this.isAnimationEnabled = false;
    this.animationInstance = null;
    this.intervalId = null;
  }

  getAnimationSettings(originXA: number, originXB: number) {
    return {
      startVelocity: 100,
      spread: 360,
      ticks: 250,
      zIndex: 10,
      particleCount: 500,
      origin: {
        x: randomInRange(originXA, originXB),
        y: Math.random() - 0.2
      }
    }
  }

  nextTickAnimation =()=> {
    this.animationInstance && this.animationInstance(this.getAnimationSettings(0.1, 0.9));
  }

  startAnimation() {
    if (!this.isAnimationEnabled) {
      this.isAnimationEnabled = true;
      this.intervalId = setInterval(this.nextTickAnimation, 1300);
    }
    setTimeout(() => {
      this.isAnimationEnabled = false;
      this.intervalId && clearInterval(this.intervalId)}, 3900);

    setTimeout(() => this.props.stopAnimation && this.props.stopAnimation(), 8000);
  }

  pauseAnimation() {
    this.isAnimationEnabled = false;
    return this.intervalId && clearInterval(this.intervalId);
  }

  stopAnimation() {
    this.isAnimationEnabled = false;
    this.animationInstance && this.animationInstance.reset();
    return this.intervalId && clearInterval(this.intervalId);
  }

  handlerClickStart = () => {
    this.startAnimation();
  }

  handlerClickPause = () => {
    this.pauseAnimation();
  }

  handlerClickStop = () => {
    this.stopAnimation();
  }
  componentDidMount() {
    this.props.isFire && this.startAnimation()
  }

  componentWillUnmount() {
    this.isAnimationEnabled = false;
    this.intervalId && clearInterval(this.intervalId);
  }

  getInstance = (instance: any) => {
    this.animationInstance = instance
  }

  render() {
    return (
      <Portal>
        <ReactCanvasConfetti refConfetti={this.getInstance} style={canvasStyles as any}/>
      </Portal>
    );
  }
}